import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { SideListOptionType } from '@fi-shared/types';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { ItemsListComponent } from '@fi-app/components/items-list/items-list.component';

@Component({
    selector: 'items-list-actions',
    styleUrls: ['./items-list-actions.component.scss'],
    template: `
        @if (isActionsButtonShown()) {
          <fi-items-list-actions
            class="hide-mobile"
            [actions]="actions"
            [disabled]="!selectedItems.length"
            >
          </fi-items-list-actions>
        }
        `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'items-list-actions' },
    standalone: false,
})
export class ItemsListActionsComponent implements OnInit, OnChanges {
    @Input() selectedItems: any[] = [];
    @Input() filterType: SideListOptionType = SideListOptionType.SharedWithMe;
    @Input() itemsListComponent: ItemsListComponent;
    @Input() stateName: string = '';
    @Input() buttons: IItemsListAction2[] = [];
    @Input() deleteButtonText: string;
    actions: IItemsListAction2[] = [];

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit(): void {
        this.setActions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setActions();
    }

    isActionsButtonShown(): boolean {
        return !!this.actions.length;
    }

    setActions(): void {
        this.actions = this.buttons.slice();
        const moduleAccessRight = this.stateAccessCheckService.isStateAllowedForCurrentUser(this.stateName);
        const isDeletedItems = this.filterType === SideListOptionType.Deleted;
        const deleteAction = {
            title: this.getDeleteButtonText(isDeletedItems),
            onClick: () =>
                isDeletedItems ? this.itemsListComponent.DeletePermanently() : this.itemsListComponent.Delete(),
        };

        if (isDeletedItems) {
            this.actions.push({
                title: this.appTextService.get('common.restore'),
                onClick: () => this.itemsListComponent.Restore(),
            });
            this.actions.push(deleteAction);
        } else {
            if (moduleAccessRight) this.actions.push(deleteAction);

            // this.actions.push({
            //     title: this.appTextService.get('common.change_owner'),
            //     onClick: () => {
            //         // todo: implement new feature
            //     }
            // });
        }
    }

    private getDeleteButtonText(isDeletedItems: boolean): string {
        if (this.deleteButtonText) return this.deleteButtonText;

        return this.appTextService.get(isDeletedItems ? 'common.delete_permanently' : 'common.delete');
    }
}
